import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { withTrackingParams } from '../utils/trackingParams';

/**
 * Barra de compra fija (mobile y desktop). El precio se revela por primera vez
 * en la tarjeta de oferta, así que la barra permanece oculta hasta que esa
 * tarjeta entra en pantalla, y se esconde al llegar al footer.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const offer = document.getElementById('comprar');
      const offerReached = offer ? offer.getBoundingClientRect().top <= window.innerHeight * 0.85 : false;
      const footer = document.getElementById('site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(offerReached && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    // Las secciones se cargan en diferido: al montarse cambia la altura del
    // documento y hay que recalcular dónde quedó la tarjeta de oferta.
    const observer = new ResizeObserver(onScroll);
    observer.observe(document.body);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone bg-white/95 backdrop-blur transition-transform duration-300 ease-out ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-234" data-mp="363ysklwj9i5l">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-1.5 sm:py-2.5" data-id="element-235" data-mp="2f3zbj47qi4v3">
        <div className="min-w-0" data-id="element-236" data-mp="2a54ti4hlckc1">
          <p className="truncate font-display text-[0.58rem] font-bold uppercase tracking-[0.1em] text-taupe sm:text-[0.66rem]" data-id="element-237" data-mp="2o32w6cmjusbp">
            200 Fórmulas de Jabones Artesanales de Glicerina
          </p>
          <div className="flex items-baseline gap-1.5" data-id="element-238" data-mp="2xzz5gkk9vihb">
            <p className="font-display text-[1.25rem] font-extrabold leading-none tracking-tight tabular-nums text-charcoal sm:text-[1.4rem]" data-id="element-239" data-mp="2xyo4esi7ootw">
              {PRICE.current}
            </p>
            <p className="font-sans text-[0.68rem] tabular-nums text-taupe/70" style={{
            textDecoration: 'line-through'
          }} data-id="element-240" data-mp="37pr5vvf1z5tp">
              {PRICE.previous}
            </p>
            <p className="hidden font-sans text-[0.7rem] font-semibold text-gold-deep sm:block" data-id="element-241" data-mp="3gow0iqnhuf0l">
              USD · Pago único<span className="hidden md:inline" data-id="element-242" data-mp="3vdxn1k2d1sqw"> · Sin suscripción</span>
            </p>
          </div>
        </div>
        <a href={withTrackingParams(CHECKOUT_URL)} onClick={event => {
        event.currentTarget.href = withTrackingParams(CHECKOUT_URL);
        trackInitiateCheckout();
      }} tabIndex={visible ? 0 : -1} className="cta-gradient flex min-h-[46px] max-w-[12rem] shrink-0 items-center justify-center rounded-xl px-5 py-2 text-center font-display text-[0.78rem] font-bold uppercase leading-[1.15] tracking-[0.03em] text-white shadow-[0_12px_26px_-12px_rgba(106,63,184,0.8)] transition-transform duration-200 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:max-w-none" data-id="element-243" data-mp="48600tjvqw8b">
          <span className="sm:hidden" data-id="element-244" data-mp="2tolncsob30zx">Sí, quiero comprar el pack completo</span>
          <span className="hidden sm:inline" data-id="element-245" data-mp="2tqxz2o3h0f4j">
            Sí, quiero comprar el pack completo · {PRICE.current}
          </span>
        </a>
      </div>
    </div>;
}